// extracted by mini-css-extract-plugin
module.exports = {"ldsRoller":"Loading_ldsRoller__K0J4Q","lds-roller":"Loading_lds-roller___IpHo"};